import React, { FC, useContext } from 'react'
import theme from '../../../../../../theme'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Link as RouterLink } from 'react-router-dom'
import { PAGE_ALERTS } from '../../../../../../constants/navigation'
import { Link } from '@mui/material'
import { ClosePopoversContext } from '../../../../../../components/ClosePopoversProvider'

const SidebarAlertsHead: FC = () => {
	const onClosePopup = useContext(ClosePopoversContext)

	return (
		<Box
			py={4}
			px={6}
			borderBottom={1}
			borderColor={theme.palette.grey[300]}
			display={'flex'}
			alignItems={'center'}
			justifyContent={'space-between'}
		>
			<Typography variant={'h5'} component={'h2'} fontSize={'1.25rem'}>
				Recent alerts
			</Typography>

			<Link
				to={PAGE_ALERTS}
				component={RouterLink}
				maxWidth={'11rem'}
				onClick={onClosePopup}
				sx={{
					fontFamily: 'Gilroy-Medium, sans-serif',
					color: theme.palette.dark.main,
				}}
				lineHeight={'normal'}
			>
				See all alerts
			</Link>
		</Box>
	)
}

export default SidebarAlertsHead
